import React from "react";
import { Modal, ModalDialog, Typography, Box } from "@mui/joy";

function Popup({ open, title, titleIcon, content, actions, onClose }) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          {titleIcon && <span className="modal-icon">{titleIcon}</span>}
          <Typography level="h4">{title}</Typography>
        </Box>

        <Box sx={{ my: 2 }}>
          {typeof content === "string" ? (
            <Typography>{content}</Typography>
          ) : (
            content
          )}
        </Box>

        {actions && (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              justifyContent: "flex-end",
              mt: 2,
            }}
          >
            {actions}
          </Box>
        )}
      </ModalDialog>
    </Modal>
  );
}

export default Popup;
